export function getFieldValue(Data, FieldID){
    if (Data == undefined || Data == null)
        return null;

    if (FieldID in Data == false)
        return null;

    return Data[FieldID];

}

export function getArraySorted_ZOrder(Data, FieldID){
    var arr = getFieldValue(Data, FieldID);
    if (arr == undefined || arr == null)
        return null;

    return arr.sort((a, b) => a.ZOrder - b.ZOrder);
}
